class Wishlist {
  constructor() {
    this.isWishlistPage = false
    this.storageKey = 'm-wishlist-products'
    this.products = []
    this.productNodes = {}

    this.pageTemplate = 'page.wishlist'
    this.addedClass = 'added-to-wishlist'
    this.hasItemClass = 'wishlist-has-item'
    this.selectors = {
      container: '.m-wishlist-page-content__wrapper',
      noProducts: '.m-wishlist-no-products',
      wrapper: '.m-wishlist-card',
      productCard: '.m-product-card',
      wishlistButton: '.m-wishlist-button',
      wishlistText: '.m-wishlist-button-text',
      removeButton: '.m-wishlist-remove-button',
      count: '.m-wishlist-count'
    }
    this.products = Array.from(
  new Set(
    (JSON.parse(localStorage.getItem(this.storageKey)) || [])
      .map(item => typeof item === 'string' ? item : item?.handle)
      .filter(Boolean)
  )
)

this.savedVariantsKey = 'luxford-wishlist-variants'

try {
  const savedVariants = JSON.parse(
    localStorage.getItem(this.savedVariantsKey) || '{}'
  )

  this.savedVariants =
    savedVariants &&
    typeof savedVariants === 'object' &&
    !Array.isArray(savedVariants)
      ? savedVariants
      : {}
} catch (error) {
  this.savedVariants = {}
}
    this.isWishlistPage = MinimogSettings.template === this.pageTemplate
    this.init()
  }

  init = async () => {
    this.hasSelectedWishlistSize = false

const sizePicker = document.querySelector(
  '.main-product__block [data-option-name]'
)

if (sizePicker) {
  sizePicker.addEventListener('change', (event) => {
    if (event.target.matches('input[type="radio"], select')) {
      this.hasSelectedWishlistSize = true
    }
  })
}
    if (this.isWishlistPage) {
      await this.renderWishlistPage()
      this.addEventToRemoveButtons()
    }
    this.setWishlistButtonsState()
    this.addEventToWishlistButtons()
    this.updateWishlistCount()
  }

  saveToStorage = () => {
    this.products = Array.from(new Set(this.products))
    localStorage.setItem(this.storageKey, JSON.stringify(this.products))
  }
  /* LUXFORD — Variant-specific wishlist storage */

saveVariantToWishlist = (handle, variantId) => {
  if (!handle || !variantId) return

  this.savedVariants[handle] = String(variantId)

  localStorage.setItem(
    this.savedVariantsKey,
    JSON.stringify(this.savedVariants)
  )
}

getSavedVariant = (handle) => {
  return this.savedVariants[handle] || null
}

removeSavedVariant = (handle) => {
  delete this.savedVariants[handle]

  localStorage.setItem(
    this.savedVariantsKey,
    JSON.stringify(this.savedVariants)
  )
}

  addToWishlist(handle) {
    if (handle && this.products.indexOf(handle) === -1) {
      this.products.push(handle)
      this.saveToStorage()
    }
  }

  removeFromWishlist(handle) {
    this.products = this.products.filter(hdl => hdl !== handle)
    this.saveToStorage()
  }

  setWishlistButtonsState = () => {
    const buttons = document.querySelectorAll(this.selectors.wishlistButton)
    buttons.forEach(btn => {
      const prodHandle = btn && btn.dataset.productHandle
      if (this.products.indexOf(prodHandle) >= 0 && btn && !btn.classList.contains(this.addedClass)) {
        this.toggleButtonState(btn, true)

        if (this.isWishlistPage) {
          btn.classList.remove(this.selectors.wishlistButton.replace('.', ''))
          btn.classList.add(this.selectors.removeButton.replace('.', ''))
        }
      }
    })
  }

  updateWishlistCount = () => {
    const size = this.products.length
    const countElems = document.querySelectorAll(this.selectors.count);
    [...countElems].forEach(elem => {
      elem.textContent = size
      if (size < 1) {
        elem.classList.add('m:hidden')
      } else {
        elem.classList.remove('m:hidden')
      }
    })
    const method = size ? 'add' : 'remove'
    document.body.classList[method](this.hasItemClass)
  }

  addEventToWishlistButtons = () => {
  addEventDelegate({
    selector: this.selectors.wishlistButton,
    handler: (e, btn) => {
      e.preventDefault()

      const productHandle = btn && btn.dataset.productHandle

      if (productHandle) {
        const active = !btn.classList.contains(this.addedClass)
        const productPage = btn.closest('product-info') || document.querySelector('product-info')
        // Luxford — product-card wishlist size selection
if (active && !productPage && btn.closest('.m-product-card')) {
  this.openWishlistSizePopup(btn, productHandle)
  return
}

        // Require deliberate size selection on product pages
        if (active && productPage) {
          const sizePicker = document.querySelector(
            '.main-product__block [data-option-name*="size" i]'
          )

          if (sizePicker && !sizePicker.dataset.selectedValue) {
  sizePicker.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  })

  const sizeLabel = sizePicker.querySelector(
    '.option-label--selected'
  )

  if (sizeLabel) {
    sizeLabel.classList.remove('luxford-size-attention')

    // Restart animation on repeated clicks
    void sizeLabel.offsetWidth

    sizeLabel.classList.add('luxford-size-attention')
  }

  return
}
        }

        // Save selected variant when adding
if (active && productPage) {
  const variantId = productPage.querySelector(
  'input[name="id"]'
)?.value

  if (variantId) {
    this.saveVariantToWishlist(productHandle, variantId)
  }
}

        // Clear saved variant when removing
        if (!active) {
          this.removeSavedVariant(productHandle)
        }

        this.toggleButtonState(btn, active)
        this.updateWishlistCount()

        document.querySelectorAll(this.selectors.wishlistButton).forEach(btnItem => {
          if (
            btnItem &&
            btnItem.dataset.productHandle === productHandle &&
            btnItem !== btn
          ) {
            const isAdded = !btnItem.classList.contains(this.addedClass)
            this.toggleButtonState(btnItem, isAdded)
          }
        })
      }
    }
  })
}

// Luxford — product-card wishlist size selection
openWishlistSizePopup = async (btn, productHandle) => {
  // Prevent duplicate pop-ups
  document.querySelector('.luxford-wishlist-overlay')?.remove()

  const overlay = document.createElement('div')
  overlay.className = 'luxford-wishlist-overlay'
  overlay.setAttribute('role', 'presentation')

  const popup = document.createElement('div')
  popup.className = 'luxford-wishlist-popup'
  popup.setAttribute('role', 'dialog')
  popup.setAttribute('aria-modal', 'true')
  popup.setAttribute('aria-label', 'Select a size')

  popup.innerHTML = `
    <button type="button" class="luxford-wishlist-close" aria-label="Close">&times;</button>
    <div class="luxford-wishlist-popup-title">Select a Size</div>
    <div class="luxford-wishlist-size-label" hidden>
    <span class="luxford-wishlist-size-name">UK Size:</span>
    <span class="luxford-wishlist-selected-size">Select Size</span>
    </div>
    <div class="luxford-wishlist-sizes">Loading sizes ...</div>
    <button type="button" class="luxford-wishlist-confirm" disabled>
      Add to Wishlist
    </button>
  `

  overlay.appendChild(popup)
  document.body.appendChild(overlay)

  const close = () => {
    overlay.remove()
    document.removeEventListener('keydown', onKeyDown)
  }

  const onKeyDown = (event) => {
    if (event.key === 'Escape') close()
  }

  document.addEventListener('keydown', onKeyDown)

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) close()
  })

  popup.querySelector('.luxford-wishlist-close')
    .addEventListener('click', close)

  const sizesContainer = popup.querySelector('.luxford-wishlist-sizes')
  const confirmButton = popup.querySelector('.luxford-wishlist-confirm')

  try {
    const response = await fetch(
      `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(productHandle)}.js`
    )

    if (!response.ok) throw new Error('Unable to load product')

    const product = await response.json()
    const variants = product.variants || []

    let selectedVariant = null

    sizesContainer.textContent = ''

    if (!variants.length) {
      sizesContainer.textContent = 'No sizes available.'
      return
    }

    const sizeLabel = popup.querySelector('.luxford-wishlist-size-label')

if (sizeLabel) {
  sizeLabel.hidden = false
}
    variants.forEach((variant) => {
      const sizeButton = document.createElement('button')
      sizeButton.type = 'button'
      sizeButton.className = 'luxford-wishlist-size'
      sizeButton.textContent = variant.option1

      if (!variant.available) {
        sizeButton.classList.add('is-unavailable')
      }

      sizeButton.addEventListener('click', () => {
        sizesContainer.querySelectorAll('.luxford-wishlist-size')
          .forEach((button) => button.classList.remove('is-selected'))

        sizeButton.classList.add('is-selected')
        selectedVariant = variant
        const sizeLabel = popup.querySelector('.luxford-wishlist-size-label')

if (sizeLabel) {
  const sizeName = sizeLabel.dataset.sizeName || 'UK Size'
  sizeLabel.innerHTML = `
  <span class="luxford-wishlist-size-name">${sizeName}:</span>
  <span class="luxford-wishlist-selected-size">${variant.option1}</span>
`
}
        confirmButton.disabled = false
      })

      sizesContainer.appendChild(sizeButton)
    })

    confirmButton.addEventListener('click', () => {
      if (!selectedVariant) return

      this.saveVariantToWishlist(productHandle, selectedVariant.id)

      // Add product and update matching wishlist hearts
      document.querySelectorAll(this.selectors.wishlistButton)
        .forEach((wishlistButton) => {
          if (wishlistButton.dataset.productHandle === productHandle &&
              !wishlistButton.classList.contains(this.addedClass)) {
            this.toggleButtonState(wishlistButton, true)
          }
        })

      this.updateWishlistCount()
      close()
    })
  } catch (error) {
    console.error('Luxford wishlist:', error)
    sizesContainer.textContent = 'Unable to load sizes. Please try again.'
  }
}

  toggleButtonState = (btn, active) => {
    const productHandle = btn && btn.dataset.productHandle
    const wishlistText = btn && btn.querySelector(this.selectors.wishlistText)

    if (active) {
      this.addToWishlist(productHandle)
      btn.classList.add(this.addedClass)
    } else {
      this.removeFromWishlist(productHandle)
      btn.classList.remove(this.addedClass)
    }

    if (wishlistText) {
      const temp = wishlistText.dataset.revertText
      wishlistText.dataset.revertText = wishlistText.textContent
      wishlistText.textContent = temp
    }
  }

  addEventToRemoveButtons = () => {
    addEventDelegate({
      selector: this.selectors.removeButton,
      handler: (e, btn) => {
        e.preventDefault()
        const prod = btn && btn.closest(this.selectors.wrapper)
        prod && prod.remove()

        const productHandle = btn && btn.dataset.productHandle
        if (productHandle) {
          this.removeFromWishlist(productHandle)
          this.updateWishlistCount()
          if (!this.products.length) {
            this.showNoProductsMessage()
          }
        }
      }
    })
  }

  wishlistRemoveButton(prdHandle) {
    const html = `<svg class="m-svg-icon--medium" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>`;
    const button = document.createElement("DIV");
    button.classList.add("m-tooltip", "m-wishlist-remove-button", "m:block", "md:m:hidden");
    button.setAttribute("data-product-handle", prdHandle);
    button.innerHTML = html;
    return button;
  }

  renderWishlistPage = async () => {
    const container = document.querySelector(this.selectors.container)
    if (container) {
      let noItemAvailable = true
      if (this.products.length) {
        const promises = this.products.map(async hdl => {
          const url = formatUrl('products', hdl, 'view=grid-card-item')
          const prodHTML = await fetchCache(url)
          const item = document.createElement("DIV");
          item.classList.add("m:hidden", "m:column", "m-wishlist-card");
          item.innerHTML = prodHTML
          if (item.querySelector(this.selectors.productCard)) {
  noItemAvailable = false

  // LUXFORD — Display saved wishlist size
  const savedVariantId = this.getSavedVariant(hdl)

  if (savedVariantId) {
    try {
      const response = await fetch(
        window.Shopify.routes.root + 'products/' + hdl + '.js'
      )

      if (response.ok) {
        const product = await response.json()

        const variant = product.variants.find(
          v => String(v.id) === String(savedVariantId)
        )

        if (variant) {
          // LUXFORD — Dynamic wishlist size badge
const sizeOption = product.options?.[0]?.name || 'Size'
const sizeValue = variant.option1

const formatWishlistSize = (label, value) => {
  const name = String(label).trim()
  const size = String(value).trim()

  if (/^UK Size \(Women's\)$/i.test(name)) {
    return `UK Women's ${size}`
  }

  if (/^UK Size$/i.test(name)) {
    return `UK ${size}`
  }

  if (/^EU Size$/i.test(name)) {
    return `EU ${size}`
  }

  if (/^US Size$/i.test(name)) {
    return `US ${size}`
  }

  if (/^Size$/i.test(name)) {
    return size
  }

  if (/^One Size$/i.test(name)) {
    return 'One Size'
  }

  return `${name}: ${size}`
}

const sizeBadge = document.createElement('span')
sizeBadge.className = 'luxford-wishlist-size-badge'
sizeBadge.textContent = formatWishlistSize(sizeOption, sizeValue)

const productCard = item.querySelector(this.selectors.productCard)

// LUXFORD — Place size badge above product image
const imageContainer = productCard.querySelector(
  '.m-product-card__media'
)

if (imageContainer) {
  imageContainer.insertAdjacentElement('afterend', sizeBadge)
}
          // LUXFORD — Add saved wishlist variant to bag
const addButton = document.createElement('button')
addButton.type = 'button'
addButton.className = 'luxford-wishlist-add-to-bag'
addButton.textContent = 'Add to Bag'

addButton.addEventListener('click', async () => {
  if (addButton.disabled) return

  addButton.disabled = true
  addButton.textContent = 'Adding...'

  try {
    const sections = []

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections }
      })
    )

    const formData = new FormData()
    formData.append('id', String(variant.id))
    formData.append('quantity', '1')
    formData.append('sections', sections)
    formData.append('sections_url', window.location.pathname)

    const response = await fetch(
  window.Shopify.routes.root + 'cart/add.js',
  {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json'
    },
    body: formData
  }
)

    const result = await response.json()

    if (!response.ok || result.status) {
      throw new Error(result.description || result.message || 'Unable to add item')
    }

    window.MinimogEvents.emit(
      window.MinimogTheme.pubSubEvents.cartUpdate,
      { cart: result, productVariantId: String(variant.id) }
    )

    document.dispatchEvent(
      new CustomEvent('product-ajax:added', {
        detail: { product: result }
      })
    )

    const cartDrawer = document.querySelector('m-cart-drawer')

    if (window.MinimogSettings.enable_cart_drawer && cartDrawer) {
      cartDrawer.open()
    } else {
      window.location.href = window.MinimogSettings.routes.cart || '/cart'
    }
  } catch (error) {
    console.error('Luxford wishlist Add to Bag:', error)
    alert(error.message)
  } finally {
    addButton.disabled = false
    addButton.textContent = 'Add to Bag'
  }
})

// LUXFORD — Position Add to Bag above product information
const productInfo = productCard.querySelector(
  '.m-product-card__info'
)

if (productInfo) {
  productInfo.parentNode.insertBefore(addButton, productInfo)
} else {
  productCard.appendChild(addButton)
}
        }
      }
    } catch (error) {
      console.warn('Luxford wishlist size unavailable:', error)
    }
  }

  item.appendChild(this.wishlistRemoveButton(hdl))
  this.productNodes[hdl] = item
}
        })

        await Promise.all(promises)

        // Render in order
        this.products.forEach(hdl => {
          const prod = this.productNodes[hdl]
          if (prod) {
            container.appendChild(prod)

            if (MinimogTheme.CompareProduct) {
              MinimogTheme.CompareProduct.setCompareButtonsState();
            }

            prod.classList.remove('m:hidden');
          }
        })
      }

      if (noItemAvailable) {
        this.showNoProductsMessage()
      } else {
        this.setWishlistButtonsState()
      }

      container.classList.add('is-visible')
    }
  }

  showNoProductsMessage = () => {
    const container = document.querySelector(this.selectors.container)
    const noProducts = document.querySelector(this.selectors.noProducts)

    container.classList.add('m:hidden')
    noProducts.classList.remove('m:hidden')
  }
}

MinimogTheme.Wishlist = new Wishlist()